// noinspection JSUnresolvedVariable

import {createReplaceableElement} from "../helpers/replaceableElement";
import {setAsDateField, setAsSelect2} from "../helpers/inputs";
import {showLoading} from "../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../helpers/handleAjaxError";
import createElement from "../helpers/createElement";
import {getInputsByName} from "../helpers/forms";

function initCustomerVendorPaymentIndex() {
	const paymentsCardComponent = createReplaceableElement({
		element: document.querySelector('.payments-card'),
		init() {
			// Setup filters
			const categoryFilter = this.getCategoryFilter();

			setAsSelect2(categoryFilter);

			$(categoryFilter).on('change', refreshCard)

			// Setup dates filters
			this.element.querySelectorAll('.date-only-input').forEach(input => {
				setAsDateField(input, {
					showClear: true,
				});

				$(input).on('dp.hide', refreshCard)
			})

			// Setup print pdf button
			this.element.querySelectorAll('.print-pdf-button').forEach(button => {
				button.addEventListener('click', () => {
					window.open(button.dataset.printUrl, '_blank');
				})
			})
		},
		getCategoryFilter() {
			return this.element.querySelector('select[name="category_filter"]');
		},
	})

	// Methods

	function refreshCard() {
		showLoading(paymentsCardComponent.element);

		const data = {
			category_id: paymentsCardComponent.getCategoryFilter().value,
		}

		const dateFilters = getInputsByName(paymentsCardComponent.element, ['from', 'to']);

		data.from = dateFilters.from ? dateFilters.from : undefined;
		data.to = dateFilters.to ? dateFilters.to : undefined;

		Axios.post(window['projects.vendor-payment.index.payment-card'], data)
			.then(response => {
				const card = createElement(response.data.card);

				paymentsCardComponent.replace(card);
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initCustomerVendorPaymentIndex}
